import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import {FormattedMessage} from 'react-intl';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import FormContext from './FormContext';
import {HelpButton} from '../../common/button';
import dataUtils from '../../../util/DataUtils';

const textField = ({disabled, field, fullWidth, helpButton, input, label, messageId, meta, meta: {active, error, touched, warning}, onKeyDown, ...rest}) => {

    function handleKeyDown(e) {
        if (e.keyCode === 13 && !e.shiftKey && !!onKeyDown) {
            return onKeyDown(e);
        } else if (e.keyCode === 9) {
            e.stopPropagation();
        }
    }

    function handleOnBlur(e) {
        return input.onBlur(dataUtils.trimField(e));
    }

    return (
        <FormControl disabled={disabled} fullWidth={fullWidth === undefined ? true : fullWidth}>
            <InputLabel htmlFor={field} shrink>
                {messageId ? <FormattedMessage id={messageId}/> : label}
                {helpButton && !React.isValidElement(helpButton) ? <HelpButton {...helpButton}/> : helpButton}
            </InputLabel>
            <Input
                id={field}
                spellCheck
                onKeyDown={handleKeyDown}
                {...input}
                onBlur={handleOnBlur}
                {...rest}
            />
            <FormHelperText error={!!error ? !!error : undefined}>
                {do {
                    if (((active && input.value) || touched) && !!error) {
                        error;
                    } else if (active && !error && !!warning) {
                        warning;
                    }
                }}
            </FormHelperText>
        </FormControl>
    );
};

const TextInput = ({field, label, show, type, ...rest}) => {

    if (show !== undefined && !show) {
        return null;
    }

    return (
        <FormContext.Consumer>
            {context => {
                return (
                    <span className="input">
                        <Field
                            component={textField}
                            field={field}
                            label={label}
                            name={field}
                            onKeyDown={context.handleKeyDown}
                            normalize={dataUtils.normalizeField(type)}
                            type={type}
                            {...rest}
                        />
                    </span>
                );
            }}
        </FormContext.Consumer>
    );
};

TextInput.propTypes = {
    field: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
    helpButton: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.object
    ]),
    label: PropTypes.string,
    messageId: PropTypes.string,
    show: PropTypes.bool,
    type: PropTypes.string
};

export default TextInput;


// WEBPACK FOOTER //
// ./src/components/common/form/TextInput.js